import { Injectable } from '@angular/core';

import { environment } from '../environment';

import { Api } from './api';

@Injectable({
    providedIn: 'root'
})
export class MapLayerUsageApi {
    constructor(private readonly api: Api) { }

    async saveMapUsage(mapId: number, filter: string, district: number) {
        return await this.api.http2.graphqlRequest<number>(`
        mutation AddMapUsage($mapId: Int!, $filter: String!, $district: Int!, $applicationId: Int!) {
            addMapUsage(mapId: $mapId, filter: $filter, district: $district, applicationId: $applicationId)
        }`, { mapId, district, filter, applicationId: environment.appId }, 'POST', 'addMapUsage');
    }

    async saveLayerUsage(layerId: number, filter: string, district: number) {
        return await this.api.http2.graphqlRequest<number>(`mutation AddLayerUsage($layerId: Int!, $filter: String!, $district: Int!, $applicationId: Int!) {
            addLayerUsage(layerId: $layerId, filter: $filter, district: $district, applicationId: $applicationId)
        }`, { layerId, district, filter, applicationId: environment.appId }, 'POST', 'addLayerUsage');
    }
}
